// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".branded[data-v-e51011f6]{color:#4abca5}.table-shadow[data-v-e51011f6]{border:2px solid rgba(0,128,0,.35)}.brand[data-v-e51011f6]{color:#837d89}.content-box[data-v-e51011f6]{text-align:center;margin:60px 25px 60px 25px}", ""]);
// Exports
module.exports = exports;
